/**
 * DynamicFavicon Component
 *
 * Dynamically updates the browser favicon based on tenant branding.
 * Falls back to default favicon if none is specified.
 */

import { useEffect } from 'react';

interface DynamicFaviconProps {
  /** URL to the favicon (typically .ico or .svg, 32x32 or 48x48) */
  url?: string;
}

export function DynamicFavicon({ url }: DynamicFaviconProps) {
  useEffect(() => {
    if (!url) {
      return;
    }

    // Find existing favicon link element
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");

    if (link) {
      // Update existing favicon
      link.href = url;
    } else {
      // Create new favicon link
      link = document.createElement('link');
      link.rel = 'icon';
      link.href = url;
      document.head.appendChild(link);
    }

    // Cleanup: Restore original favicon on unmount (optional)
    // In practice, we usually want to keep the custom favicon
  }, [url]);

  // This is a headless component - renders nothing
  return null;
}
